import React, { FC, useCallback } from 'react'

import { FORM_ELEMENTS } from '../types'

import * as SC from './styled'

export type Radio = {
  label: string
  id: string | boolean
  disabled?: boolean
}

export type RadioGroupProps = {
  className?: string
  legend?: string
  name?: string
  items?: Radio[]
  value?: string
  type?: FORM_ELEMENTS.RADIO_GROUP
  onChange: (name?: string, value?: string | boolean) => void
}

const RadioGroup: FC<RadioGroupProps> = (props) => {
  const { className, items, legend, name, onChange, value } = props

  const handleRadioChange = useCallback(
    (c: Radio) => {
      onChange?.(name, c.id)
    },
    [onChange, name]
  )

  return (
    <SC.Group className={className}>
      {name && <SC.Legend>{legend}</SC.Legend>}
      {items?.map((c) => (
        <SC.RadioWrapper
          checked={value === c?.id ?? false}
          key={`${c?.id}`}
          disabled={c?.disabled ?? false}
        >
          <SC.Radio
            type="radio"
            id={`${c?.id}`}
            name={name}
            checked={value === c?.id ?? false}
            onChange={() => handleRadioChange(c)}
            onClick={() => handleRadioChange(c)}
            disabled={c?.disabled ?? false}
          />
          <SC.Circle />
          <SC.Label htmlFor={`${c?.id}`}>{c?.label}</SC.Label>
        </SC.RadioWrapper>
      ))}
    </SC.Group>
  )
}

export default RadioGroup
